var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0V2H20V4H22V6H24V18H22V20H20V22H18V24H6V22H4V20H2V18H0V6H2V4H4V2H6V0H18Z",
    fill: "#2775CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0V2H20V4H22V6H24V18H22V20H20V22H18V24H6V22H4V20H2V18H0V6H2V4H4V2H6V0H18Z",
    fill: "#009393"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 19H11V18H10V17H9V16H8V15H7V14H6V13H5V12H4V9H5V8H6V7H7V6H17V7H18V8H19V9H20V12H19V13H18V14H17V15H16V16H15V17H14V18H13V19ZM8 12.5H9.00293V13H10V13.5H11.0029V14H11V16H13V13.5H14.0039V13H15.001V12.5H16V12.0078H15.0088V12.2539H14.0049V12.5H10V12.2539H8.99609V12.0078H8V12.5ZM9 9H11V10H10V10.5H9.00293V11H8V11.5078H8.99609V11.2539H10V11H11.0049V12H13V11H14.0049V11.2539H15.0088V11.5078H16V11H15.001V10.5H14.0039V10H13V9H15V8H9V9Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.62f9eceb8367531bdd4a868aef20302f.svg";
export { ForwardRef as ReactComponent };